/*
 * callec-plp-more.js — コレクションページ改修 S-037 段階3(2026-10-07)
 * F もっと見る(R3-1・R3-3・R3-4)と戻り位置の復元(R3-2)。
 *
 *   条件なし : ボタンは <a href="?page=N+1">。JS が動くときは横取りし、Section Rendering API で次のページを同じ一覧に足す。
 *              足したら ?page を replaceState で更新(?page=N は「N ページ目まで読み込み済み」)。
 *              番号リンク(前へ・1 2 3…・次へ)はボタンの下に小さく残す(検索エンジンがたどれるように)
 *   直接 ?page=N に来た人 : N ページ目だけを出し、一覧の上に「前の商品を見る」(押すと前のページを上に足す)
 *   条件付き : 絞り込み(callec-plp-filter.js)が同じ部品を使う(renderFilter / onFilterMore)
 *   読み込み中 : 足す件数ぶんの仮の枠を先に置き、届いたら差し替える(レイアウトのずれを抑える)
 *   復元     : 商品ページへ移る前に sessionStorage へ「URL・読み込んだ範囲・押した商品・スクロール位置」を保存(30 分)。
 *              戻る(bfcache)で戻れたら何もしない。戻れなかったら、保存した範囲を取り直して並べ、押したカードを画面の上 1/3 に合わせる
 *   計測     : callec:plp_load_more(page_loaded, shown_count, total_count)/ callec:plp_restore(method, pages, success)
 */
(function () {
  'use strict';

  var KEY = 'cplp:pos';
  var TTL = 30 * 60 * 1000;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function cols(grid) { return $all(':scope > .f-column:not(.cplp-skel)', grid); }

  function readRec() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function writeRec(rec) {
    try { sessionStorage.setItem(KEY, JSON.stringify(rec)); } catch (e) { /* 保存できなくても通常どおり動く */ }
  }

  function urlWithPage(n, extra) {
    var q = new URLSearchParams(location.search);
    q.delete('page');
    var qs = q.toString().replace(/%2C/gi, ',');
    if (n > 1) qs += (qs ? '&' : '') + 'page=' + n;
    if (extra) qs += (qs ? '&' : '') + extra;
    return location.pathname + (qs ? '?' + qs : '');
  }

  function handleOf(href) {
    var m = String(href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function More(box) {
    this.box = box;
    this.el = $('[data-cplp-more]', box);
    this.body = $('[data-cplp-more-body]', this.el);
    this.live = $('[data-cplp-more-live]', this.el);
    this.grid = $('[data-products-grid]', box);
    this.prev = $('[data-cplp-more-prev]', box);
    var d = this.el.dataset;
    this.sid = d.sectionId;
    this.first = this.last = Number(d.page) || 1;
    this.pages = Number(d.pages) || 1;
    this.total = Number(d.total) || 0;
    this.per = Number(d.per) || 24;
    this.showNav = d.nav !== 'false';
    var nav = $('[data-cplp-more-nav]', this.el);
    this.navHtml = nav ? nav.outerHTML : '';
    var spin = $('template[data-cplp-more-spin]', this.el);
    this.spin = spin ? spin.innerHTML : '';
    this.mode = 'base';
    this.filter = null;
    this.loading = false;
    this.onFilterMore = null;
    var self = this;
    this.hasPlp = !!$('[data-cplp-fbar]', box);
    this.plpReady = this.hasPlp ? new Promise(function (res) { self.resolvePlp = res; }) : Promise.resolve(false);
    box.__cplpMore = this;
    this.bind();
    this.render();
    this.updatePrev();
  }

  More.prototype.publish = function (name, data) {
    try {
      if (name === 'callec:plp_restore') window.__cplpRestore = data; // 確認用(最後の復元結果)
      if (!(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function')) return;
      var m = location.pathname.match(/\/collections\/([^/?#]+)/);
      var t = document.body.className.match(/template-[\w-]+/);
      Shopify.analytics.publish(name, Object.assign({}, data, {
        collection_handle: m ? decodeURIComponent(m[1]) : '',
        template: t ? t[0] : '',
        products_count: this.total
      }));
    } catch (e) { /* 計測の失敗で操作を止めない */ }
  };

  /* ---------- 表示 ---------- */
  More.prototype.state = function () {
    if (this.mode === 'filter' && this.filter) {
      var f = this.filter;
      return { total: f.total, shown: f.shown, rest: Math.max(0, f.total - f.shown), href: '#', nav: false, error: f.error };
    }
    var shown = cols(this.grid).length;
    var rest = this.last < this.pages ? Math.max(0, this.total - this.last * this.per) : 0;
    return { total: this.total, shown: shown, rest: rest, href: urlWithPage(this.last + 1), nav: this.showNav, error: this.error };
  };

  More.prototype.render = function () {
    /* 1 ページに収まる一覧(条件なし)では出さない */
    if (this.mode === 'hidden' || (this.mode === 'base' && this.pages <= 1)) { this.el.hidden = true; return; }
    var s = this.state(), per = this.per;
    var html = '';
    if (s.total > 0) {
      var pct = Math.min(100, Math.round((s.shown / s.total) * 100));
      html += '<p class="cplp-more__of">' + s.total + '件中 ' + s.shown + '件を表示</p>' +
        '<div class="cplp-more__line" aria-hidden="true"><span style="width:' + pct + '%"></span></div>';
    }
    if (s.error) html += '<p class="cplp-more__err" role="alert">' + s.error + '</p>';
    if (s.rest > 0) {
      html += '<a class="cplp-btn-outline cplp-more__btn" href="' + s.href + '" data-cplp-more-btn' +
        (this.loading ? ' aria-busy="true" aria-disabled="true"' : '') + '><span>もっと見る(' + Math.min(per, s.rest) +
        '件)</span><span class="cplp-more__spin" aria-hidden="true">' + this.spin + '</span></a>';
    } else if (s.total > per) {
      html += '<p class="cplp-more__of">すべて表示しました(' + s.total + '件)</p>';
    }
    if (s.nav) html += this.navHtml;
    this.body.innerHTML = html;
    this.el.hidden = !html;
  };

  More.prototype.updatePrev = function () {
    if (this.prev) this.prev.hidden = this.mode !== 'base' || this.first <= 1;
  };

  More.prototype.announce = function (text) {
    var live = this.live;
    if (!live) return;
    clearTimeout(this.liveTimer);
    this.liveTimer = setTimeout(function () { live.textContent = text; }, 300);
  };

  /* 足す件数ぶんの仮の枠(1 枚目のカードと同じ高さ) */
  More.prototype.addSkeletons = function (n, atStart) {
    var ref = cols(this.grid)[0];
    var h = ref ? ref.offsetHeight : 0;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < n; i++) {
      var sk = document.createElement('div');
      sk.className = 'f-column cplp-skel';
      sk.setAttribute('aria-hidden', 'true');
      sk.innerHTML = '<div class="cplp-skel__card"' + (h ? ' style="height:' + h + 'px"' : '') + '></div>';
      frag.appendChild(sk);
    }
    if (atStart) this.grid.insertBefore(frag, this.grid.firstChild);
    else this.grid.appendChild(frag);
  };
  More.prototype.removeSkeletons = function () {
    $all(':scope > .cplp-skel', this.grid).forEach(function (n) { n.remove(); });
  };

  /* 仮の枠を本物に差し替える(同じ位置・同じ数) */
  More.prototype.fillSkeletons = function (nodes) {
    var sks = $all(':scope > .cplp-skel', this.grid);
    nodes.forEach(function (n, i) {
      var node = document.importNode(n, true);
      if (sks[i]) sks[i].replaceWith(node);
      else if (sks.length) sks[sks.length - 1].after(node);
    });
    for (var i = nodes.length; i < sks.length; i++) sks[i].remove();
  };

  More.prototype.setBusy = function (on) {
    this.loading = on;
    var b = $('[data-cplp-more-btn]', this.el);
    if (b) {
      if (on) { b.setAttribute('aria-busy', 'true'); b.setAttribute('aria-disabled', 'true'); }
      else { b.removeAttribute('aria-busy'); b.removeAttribute('aria-disabled'); }
    }
  };

  /* ---------- 条件なし: 次・前のページ ---------- */
  More.prototype.fetchPage = function (n) {
    var url = urlWithPage(n, 'section_id=' + encodeURIComponent(this.sid));
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('page ' + r.status);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return $all('[data-products-grid] > .f-column', doc);
    });
  };

  More.prototype.loadNext = function () {
    var self = this;
    if (this.loading || this.last >= this.pages) return;
    var next = this.last + 1;
    var count = Math.min(this.per, this.total - this.last * this.per);
    this.error = '';
    this.setBusy(true);
    this.addSkeletons(count, false);
    var firstNew = null;
    this.fetchPage(next).then(function (nodes) {
      var before = cols(self.grid).length;
      self.fillSkeletons(nodes);
      firstNew = cols(self.grid)[before];
      self.last = next;
      history.replaceState(history.state, '', urlWithPage(self.last));
      self.loading = false;
      self.render();
      var shown = cols(self.grid).length;
      self.announce(nodes.length + '件追加しました。' + self.total + '件中' + shown + '件を表示');
      self.publish('callec:plp_load_more', { page_loaded: self.last, shown_count: shown, total_count: self.total });
      var link = firstNew && firstNew.querySelector('a[href]');
      if (link) link.focus({ preventScroll: true });
    }).catch(function () {
      self.removeSkeletons();
      self.loading = false;
      self.error = '読み込めませんでした。もう一度お試しください';
      self.render();
    });
  };

  /* 直接 ?page=N に来た人: 前のページを上に足す(見ている位置は動かさない) */
  More.prototype.loadPrev = function () {
    var self = this;
    if (this.loading || this.first <= 1) return;
    this.loading = true;
    var anchor = cols(this.grid)[0];
    this.fetchPage(this.first - 1).then(function (nodes) {
      var top = anchor ? anchor.getBoundingClientRect().top : 0;
      var frag = document.createDocumentFragment();
      nodes.forEach(function (n) { frag.appendChild(document.importNode(n, true)); });
      self.grid.insertBefore(frag, self.grid.firstChild);
      self.first -= 1;
      self.loading = false;
      self.updatePrev();
      self.render();
      /* 足した分と「前の商品を見る」が消えた分を打ち消して、見ていたカードを同じ位置に保つ */
      if (anchor) window.scrollBy(0, anchor.getBoundingClientRect().top - top);
    }).catch(function () { self.loading = false; });
  };

  /* ---------- 条件付き(callec-plp-filter.js から呼ぶ) ---------- */
  More.prototype.renderFilter = function (info) {
    this.mode = 'filter';
    this.filter = info;
    this.loading = false;
    this.updatePrev();
    this.render();
  };
  More.prototype.hide = function () {
    this.mode = 'hidden';
    this.updatePrev();
    this.render();
  };
  More.prototype.setBase = function () {
    this.mode = 'base';
    this.filter = null;
    this.loading = false;
    this.updatePrev();
    this.render();
  };
  /* 絞り込みが最初の表示(URL からの復元を含む)を終えたら呼ばれる */
  More.prototype.plpSettled = function (promise) {
    var res = this.resolvePlp;
    Promise.resolve(promise).then(function () { if (res) res(true); }, function () { if (res) res(false); });
  };

  /* ---------- 復元 ---------- */
  More.prototype.save = function (handle) {
    var prev = readRec();
    var keepHandle = !handle && prev && prev.path === location.pathname && prev.search === location.search &&
      Date.now() - prev.at < 5000 ? prev.handle : '';
    writeRec({
      path: location.pathname, search: location.search, first: this.first, last: this.last,
      mode: this.mode, y: Math.round(window.scrollY), handle: handle || keepHandle || '', at: Date.now()
    });
  };

  More.prototype.scrollToCard = function (rec) {
    var target = null;
    if (rec.handle) {
      var a = this.grid.querySelector('a[href*="/products/' + CSS.escape(rec.handle) + '"]');
      target = a && a.closest('.f-column');
    }
    if (target) {
      var y = target.getBoundingClientRect().top + window.scrollY - window.innerHeight / 3;
      window.scrollTo(0, Math.max(0, y));
      return true;
    }
    window.scrollTo(0, rec.y || 0);
    return !!rec.y;
  };

  /* 復元中は一覧を見えなくしておく(並べ直しと位置合わせの途中を見せず、レイアウトのずれにも数えさせない) */
  More.prototype.veil = function (on) {
    this.grid.style.visibility = on ? 'hidden' : '';
    this.el.style.visibility = on ? 'hidden' : '';
  };

  More.prototype.restore = function (rec) {
    var self = this;
    try { history.scrollRestoration = 'manual'; } catch (e) { /* 古いブラウザ */ }
    this.veil(true);
    /* 何かあっても 4 秒で必ず見えるようにする */
    var guard = setTimeout(function () { self.veil(false); }, 4000);
    var done = function (data) {
      clearTimeout(guard);
      self.veil(false);
      self.publish('callec:plp_restore', data);
    };
    this.plpReady.then(function (fromPlp) {
      if (fromPlp !== null && self.mode !== 'base') {
        /* 条件付き: 絞り込みが URL の page まで描き終えている */
        var ok = self.scrollToCard(rec);
        done({ method: 'refetch', pages: Number(new URLSearchParams(location.search).get('page')) || 1, success: ok });
        return;
      }
      var need = [];
      for (var p = Math.max(1, rec.first); p < self.first; p++) need.push(p);
      if (!need.length) {
        var ok2 = self.scrollToCard(rec);
        done({ method: 'refetch', pages: self.last - self.first + 1, success: ok2 });
        return;
      }
      /* 先に仮の枠で高さを確保し(一覧は隠したまま)、届いたら差し替えてから一度だけ押したカードに合わせる。
         途中でスクロールすると、一覧の下の「最近見た商品」などが画面内で動いてずれに数えられるため */
      self.addSkeletons(need.length * self.per, true);
      Promise.all(need.map(function (p) { return self.fetchPage(p); })).then(function (lists) {
        var nodes = [].concat.apply([], lists);
        self.fillSkeletons(nodes);
        self.first = need[0];
        self.updatePrev();
        self.render();
        var ok3 = self.scrollToCard(rec);
        done({ method: 'refetch', pages: self.last - self.first + 1, success: ok3 });
      }).catch(function () {
        self.removeSkeletons();
        window.scrollTo(0, 0);
        done({ method: 'refetch', pages: 0, success: false });
      });
    });
  };

  More.prototype.bind = function () {
    var self = this;
    this.el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cplp-more-btn]');
      if (!b) return;
      e.preventDefault();
      if (self.loading) return;
      if (self.mode === 'filter') { if (self.onFilterMore) self.onFilterMore(); }
      else self.loadNext();
    });
    if (this.prev) {
      this.prev.addEventListener('click', function (e) {
        e.preventDefault();
        self.loadPrev();
      });
    }
    /* 商品ページへ移る直前に保存(押したカードの商品を覚える) */
    this.grid.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="/products/"]');
      if (a) self.save(handleOf(a.getAttribute('href')));
    }, true);
    window.addEventListener('pagehide', function () { self.save(''); });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        self.publish('callec:plp_restore', { method: 'bfcache', pages: self.last - self.first + 1, success: true });
      }
    });
  };

  More.prototype.init = function () {
    /* 戻ったときの位置合わせはこちらで行う。ブラウザの自動復元(短いページで途中まで動く)と競合させない */
    try { history.scrollRestoration = 'manual'; } catch (e) { /* 古いブラウザ */ }
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var back = nav && (nav.type === 'back_forward' || nav.type === 'reload');
    var rec = readRec();
    if (back && rec && rec.path === location.pathname && rec.search === location.search && Date.now() - rec.at < TTL) {
      this.restore(rec);
    } else if (rec && rec.path !== location.pathname) {
      /* 別のコレクションに移ったら消す */
      try { sessionStorage.removeItem(KEY); } catch (e) { /* なし */ }
    }
  };

  function start(scope) {
    $all('[data-cplp-more]', scope || document).forEach(function (el) {
      var box = el.closest('product-grid-container') || el.parentNode;
      if (box.__cplpMore || !$('[data-products-grid]', box)) return; // 商品 0 件のコレクションでは何もしない
      new More(box).init();
    });
  }
  window.__cplpMoreStart = start;
  start();
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
